import {applyMiddleware, compose, createStore} from "redux";
import rootReducer from "./reducers";
import { persistStore, persistReducer } from 'redux-persist'
import thunk from "redux-thunk";
import storage from 'redux-persist/lib/storage' 

const persistConfig = {
    key: 'root',
    storage,
  }

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer);

let store = createStore(persistedReducer, 
    storeEnhancers(
        applyMiddleware(
            thunk
        )
    ))
let persistor = persistStore(store)


// export default {store};
export default { store, persistor };
